export const getTypographyVariables = (prefix = "default", typography) => {
  return {
    [`--${prefix}-font-size`]: typography.font_size + "px",
    [`--${prefix}-bold`]: typography.bold ? "bold" : "",
    [`--${prefix}-font-styles`]: typography.italic ? "italic" : "normal",
    [`--${prefix}-text-transform`]: typography.text_transform,
    [`--${prefix}-font-weight`]: typography.font_weight + "",
  };
};

export const getShadowValue = (shadow) => {
  return `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.spread}px ${shadow.color}`;
};

export const getPaddingValue = (padding) => {
  return `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`;
};

/**
 * Get editor color palette (theme colors + default colors)
 * Use this function with useSelect hook
 *
 * @example
 * import { useSelect } from "@wordpress/data";
 * import { getEditorColorPalette } from "../../utils/helpers";
 *
 * const colors = useSelect(getEditorColorPalette, []);
 */
export const getEditorColorPalette = (select) => {
  const settings = select("core/block-editor")?.getSettings();
  // Merge both theme colors and default colors
  const themeColors = settings?.colors || [];
  const defaultColors =
    settings?.["__experimentalFeatures"]?.color?.palette?.default || [];

  // Combine both arrays, theme colors first
  return [...themeColors, ...defaultColors];
};
